// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { useMutation } from "@apollo/client";
import { CAlert, CLoadingButton } from "@coreui/react-pro";
import Form, { useForm } from "rc-field-form";
import { useState } from "react";
import { FormField, Input } from "../../../../components/Form";
import { CREATE_LINKING_ID } from "../../../../graphql/queries/linked-id";

const CreateLinkingID = ({ definition, onFinish = () => void 0 }) => {
  const [form] = useForm();
  const [error, setError] = useState("");
  const [create, { loading }] = useMutation(CREATE_LINKING_ID);

  return (
    <>
      <Form
        form={form}
        onFinish={(variables) => {
          setError("");
          create({ variables: { ...variables, definitionId: definition.id } })
            .then(() => {
              console.log("COMPLETED");
              form.resetFields();
              onFinish();
            })
            .catch((e) => {
              console.log("MOO");
              setError(e.message);
            });
        }}
        horizontal
      >
        <div className={"d-flex gap-2"}>
          <FormField
            name={"value"}
            noStyle
            style={{ maxWidth: "50%", minWidth: "10rem" }}
            rules={[{ required: true }]}
          >
            <Input placeholder={"ID Value"} />
          </FormField>
          <div>
            <CLoadingButton loading={loading} color={"primary"} onClick={() => form.submit()}>
              Save
            </CLoadingButton>
          </div>
        </div>
      </Form>
      {error && <CAlert color={"warning"}>{error}</CAlert>}
    </>
  );
};

export default CreateLinkingID;
